











import FieldModel from '@/UI/Shared/Mixins/FieldModel'
import mixins from 'vue-typed-mixins'
import CustomMultiselect from '@/UI/Shared//CustomMultiselect.vue'
import { MultiselectOptions } from '@/UI/Shared/MultiselectOptions'
import { FetchPlacesByParishIdCommandHandlerProvider } from '@/Infrastructure/Localization/Place/Provider'
import { FetchPlacesByParishIdCommand, PlaceDto } from '@/Application/Localization/Place'

export default mixins(FieldModel).extend({
  name: 'CountySelector',
  components: { CustomMultiselect },
  props: {
    selectedParish: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: true,
      options: [] as MultiselectOptions[]
    }
  },
  computed: {
    name (): string {
      let label = ''
      this.options.forEach(opt => {
        if (opt.id === this.currentValue) {
          label = opt.label
        }
      })
      return label
    }
  },
  watch: {
    selectedParish () {
      this.loadCounties()
    },
    name (newValue: string, oldValue: string) {
      if (newValue !== oldValue) {
        this.$emit('ValueName', newValue)
      }
    }
  },
  mounted () {
    this.loadCounties()
  },
  methods: {
    loadCounties (): void {
      if (!this.selectedParish) {
        this.options = []
        this.loading = false
        return
      }
      const provider = new FetchPlacesByParishIdCommandHandlerProvider()
      const command = new FetchPlacesByParishIdCommand(parseInt(this.selectedParish, 10))
      const handler = provider.provide()
      this.loading = true
      const emptyOptions = [{ id: '', label: '-' }]
      handler.handle(command)
        .then((response: PlaceDto[]) => {
          const options = response.map(current => {
            return { id: current.code.toString(), label: current.name }
          })
          this.options = emptyOptions.concat(options)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
})
